import axios from "@axios";

export const getConfig = () => axios.get("/auto-email-reports/config");

export const updateConfig = (data) => axios.put("/auto-email-reports/config", data);

export const syncSpreadsheet = (spreadsheetUrl = null, targetTab = null) => {
  const payload = {};
  if (spreadsheetUrl) payload.spreadsheet_url = spreadsheetUrl;
  if (targetTab) payload.target_tab = targetTab;
  return axios.post("/auto-email-reports/sync-gss", payload);
};

export const getSyncStatus = () => axios.get("/auto-email-reports/sync-gss/status");

export const getActors = () => axios.get("/auto-email-reports/actors");

export const createActor = (data) => axios.post("/auto-email-reports/actors", data);

export const updateActor = (id, data) => axios.put(`/auto-email-reports/actors/${id}`, data);

export const deleteActor = (id) => axios.delete(`/auto-email-reports/actors/${id}`);

export const getPerimeters = () => axios.get("/auto-email-reports/perimeters");

export const createPerimeter = (data) => axios.post("/auto-email-reports/perimeters", data);

export const updatePerimeter = (id, data) => axios.put(`/auto-email-reports/perimeters/${id}`, data);

export const deletePerimeter = (id) => axios.delete(`/auto-email-reports/perimeters/${id}`);

export const getHistory = (limit = 50) => axios.get("/auto-email-reports/history", { params: { limit } });

export const getGssSyncHistory = (params = { limit: 50 }) => {
  const queryParams = typeof params === "object" ? { ...params, _t: Date.now() } : { limit: params, _t: Date.now() };
  return axios.get("/auto-email-reports/sync-gss/history", { params: queryParams });
};

export const triggerSend = ({
  targetDate = null,
  sendType = null,
  actionType = "immediate",
  isMonthlyRattrapage = false,
  selectedSiteIds = null,
} = {}) => {
  const body = {
    action_type: actionType,
    is_monthly_rattrapage: isMonthlyRattrapage,
  };
  if (targetDate) body.target_date = targetDate;
  if (sendType) body.send_type = sendType;
  if (selectedSiteIds && Array.isArray(selectedSiteIds)) body.selected_site_ids = selectedSiteIds;
  return axios.post("/auto-email-reports/trigger", body);
};

export const previewReports = ({
  targetDate = null,
  sendType = null,
  actionType = "immediate",
  isMonthlyRattrapage = false,
  selectedSiteIds = null,
} = {}) => {
  const body = {
    action_type: actionType,
    is_monthly_rattrapage: isMonthlyRattrapage,
  };
  if (targetDate) body.target_date = targetDate;
  if (sendType) body.send_type = sendType;
  if (selectedSiteIds && Array.isArray(selectedSiteIds)) body.selected_site_ids = selectedSiteIds;
  return axios.post("/auto-email-reports/preview", body);
};

export const getSites = () => axios.get("/auto-email-reports/sites");

const autoEmailService = {
  getConfig,
  updateConfig,
  syncSpreadsheet,
  getSyncStatus,
  getActors,
  createActor,
  updateActor,
  deleteActor,
  getPerimeters,
  createPerimeter,
  updatePerimeter,
  deletePerimeter,
  getHistory,
  getGssSyncHistory,
  triggerSend,
  previewReports,
  getSites,
  getGssDatasetYears: (datasetName) => {
    return axios.get("/auto-email-reports/weekly-imported-data/gss-dataset/years", {
      params: { dataset_name: datasetName },
    });
  },
  getGssDataset: (params) => {
    return axios.get("/auto-email-reports/weekly-imported-data/gss-dataset", { params });
  },
  patchGssOverride: (payload) => {
    return axios.patch("/auto-email-reports/weekly-imported-data/gss-dataset/override", payload);
  },
};

export default autoEmailService;



